import Repository from "./repository";

const resource = "onlineUser";

export default {
    async getProcess({ id }) {
        let endpoint = `${resource}/process/${id}`;
        var response = await Repository.get(endpoint);
        return response;
    },
    async startProcess(payload) {
        let endpoint = `${resource}/start-process`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyLeaveQueue(payload) {
        let endpoint = `${resource}/leave-queue`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyJoinPreRoom(payload) {
        let endpoint = `${resource}/join-pre-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyLeavePreRoom(payload) {
        let endpoint = `${resource}/leave-pre-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyJoinRoom(payload) {
        let endpoint = `${resource}/join-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    },
    async notifyLeaveRoom(payload) {
        let endpoint = `${resource}/leave-room`;
        let response = await Repository.post(endpoint, payload);
        return response;
    }
}